
document.addEventListener('change', function (e) {
  var s = e.target.closest ? e.target.closest('[data-cer-select]') : null;
  if (!s) return;
  var root = s.closest('.cer');
  if (!root) return;
  var o = s.options[s.selectedIndex];
  var p = root.querySelector('[data-cer-prezzo]');
  var f = root.querySelector('[data-cer-foto]');
  if (p && o.dataset.prezzo) p.innerHTML = o.dataset.prezzo;
  if (f && o.dataset.img) {
    f.removeAttribute('srcset');
    f.src = o.dataset.img;
  }
});